"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBrowser = void 0;
const isBrowser = () => {
    return Object.getPrototypeOf(Object.getPrototypeOf(globalThis)) !== Object.prototype;
};
exports.isBrowser = isBrowser;
//# sourceMappingURL=utils.js.map